import React from 'react'
import { AdvancedFilter } from 'components/Filter/AdvancedFilter'
import { ChangeApportionmentMain } from './ChangeApportionmentMain'
import { ChangeApportionmentForm } from './ChangeApportionmentForm/ChangeApportionmentForm'
import { ChangeApportionmentDetail } from './ChangeApportionmentDetail/ChangeApportionmentDetail'

const changeApportionmentRoutes = [
  /* -------------------------------------------- */
  /*                ADVANCED FILTER               */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/change-apportionment/filter',
    },
    component: (
      <AdvancedFilter
        mode="assets-change"
        app="fixed-assets"
        hasStatus
        hasDocDate
        hasDateRange
      />
    ),
  },

  /* -------------------------------------------- */
  /*                     MAIN                     */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/change-apportionment',
    },
    component: <ChangeApportionmentMain />,
  },

  /* -------------------------------------------- */
  /*                     FORM                     */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/change-apportionment/add',
    },
    component: <ChangeApportionmentForm formMode="add" />,
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/change-apportionment/:ChangeApportionmentID/edit',
    },
    component: <ChangeApportionmentForm formMode="edit" />,
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/change-apportionment/:ChangeApportionmentID/resubmit',
    },
    component: <ChangeApportionmentForm formMode="resubmit" />,
  },

  /* -------------------------------------------- */
  /*                    DETAIL                    */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/change-apportionment/:ChangeApportionmentID/detail',
    },
    component: <ChangeApportionmentDetail />,
  },

  /* -------------------------------------------- */
  /*                   WORKDESK                   */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/change-apportionment/:ChangeApportionmentID/workdesk',
    },
    component: <ChangeApportionmentDetail mode="workdesk" />,
  },
]

export default changeApportionmentRoutes
